function Footer() {
  return (
    <footer className="container mx-auto py-1 fixed bottom-0 md:left-20 bg-white dark:bg-dark-mode">
       <p className="text-2x1 text-base text-center text-dark-content dark:text-light-content w-full">
                {"ftarasow ,"}
        <a
          className="font-medium"
          href="https://pavanmg.in"
          target="_blank"
          rel="noreferrer noopener"
        >
          
        </a>{" 2025 г."}
         
        <span className="text-gradient font-medium">&nbsp;&nbsp;Веб-разработчик</span>&nbsp;&nbsp;
        <span className="text-gradient font-medium">с уважением к миру .</span>
      </p>
    </footer>
  );
}

export default Footer;